import { useCallback, useContext } from 'react';
import useHttp from './useHttp';
import AuthContext from '../context/authContext';
import { toast } from 'react-toastify';

export const useNews = () => {
  const { getAuthHeaders } = useContext(AuthContext);
  const { isLoading, error, sendRequest } = useHttp();

  const fetchNews = useCallback(async () => {
    try {
      const responseData = await sendRequest({
        url: '/api/v1/news',
        method: 'GET',
        headers: getAuthHeaders(),
      });
      return responseData;
    } catch (err) {
      throw err;
    }
  }, [getAuthHeaders, sendRequest]);

  const createNews = useCallback(
    async newsData => {
      try {
        const responseData = await sendRequest({
          url: '/api/v1/news',
          method: 'POST',
          headers: getAuthHeaders(),
          body: newsData,
        });
        toast.success('News erfolgreich erstellt');
        return responseData;
      } catch (err) {
        toast.error('Fehler beim Erstellen der News');
        throw err;
      }
    },
    [getAuthHeaders, sendRequest]
  );

  const updateNews = useCallback(
    async (newsId, newsData) => {
      try {
        const responseData = await sendRequest({
          url: `/api/v1/news/${newsId}`,
          method: 'PATCH',
          headers: getAuthHeaders(),
          body: newsData,
        });
        toast.success('News erfolgreich aktualisiert');
        return responseData;
      } catch (err) {
        toast.error('Fehler beim Aktualisieren der News');
        throw err;
      }
    },
    [getAuthHeaders, sendRequest]
  );

  const deleteNews = useCallback(
    async newsId => {
      try {
        const responseData = await sendRequest({
          url: `/api/v1/news/${newsId}`,
          method: 'DELETE',
          headers: getAuthHeaders(),
        });
        toast.success('News erfolgreich gelöscht');
        return responseData;
      } catch (err) {
        toast.error('Fehler beim Löschen der News');
        throw err;
      }
    },
    [getAuthHeaders, sendRequest]
  );

  const getNewsById = useCallback(
    async newsId => {
      try {
        const responseData = await sendRequest({
          url: `/api/v1/news/${newsId}`,
          method: 'GET',
          headers: getAuthHeaders(),
        });
        return responseData;
      } catch (err) {
        throw err;
      }
    },
    [getAuthHeaders, sendRequest]
  );

  return {
    isLoading,
    error,
    fetchNews,
    createNews,
    updateNews,
    deleteNews,
    getNewsById,
  };
};

